import Swiper, {Pagination} from "swiper";
import {hideModal, initSelects, showModal} from "../components/helpers";
import {ajaxAddToCart} from "../api/ajaxAddToCart";

export function initProductPageLanding() {
    if ($('#product_page_landing').length === 0) {
        return;
    }

    init();

    const PRODUCT_INFO = {...JSON.parse(JSON.stringify($('[data-product-info]').data('product-info')))};
    const defaultProductId = {...JSON.parse(JSON.stringify($('[data-product-info]').data('product-info')))}.id;
    const $sizesModal = $('#sizes_modal');
    const $familyInput = $('#custom_shirt_family');
    const $numberInput = $('#custom_shirt_number');

    function init() {
        initProductSlider();
        initGeneralHandlers();
        initSelects();
    }

    function initProductSlider() {
        let indexOfCustomShirtSlide = null;

        let $productSlider = new Swiper('#product-swiper', {
            slideToClickedSlide: true,
            speed: 300,
            modules: [Pagination],
            pagination: {
                el: '.product-slider-pagination',
                type: 'bullets',
                clickable: true
            }
        });

        //индекс слайда с картинкой кастомной майки
        $('#product-swiper').find('.swiper-slide').each((index, slide) => {
            if ($(slide).data('slide-with-custom-shirt') === '') {
                indexOfCustomShirtSlide = index;
            }
        });

        //раскрытие блока Дополнительно
        $('.custom-shirt-title').on('click', function () {
            $(this).toggleClass('opened');
            $('.custom-shirt-inputs').slideToggle({duration: 150});

            if ($(this).hasClass('opened')) {
                $productSlider.slideTo(indexOfCustomShirtSlide, 300, false)
            }
        });
    }

    //общие обработчики
    function initGeneralHandlers() {
        //модалка с таблицей размеров
        $('[data-sizes-table-trigger]').on('click', () => {
            showModal($sizesModal);
        });

        //закрытие модалки
        $('[data-close-cart-modal]').on('click', e => {
            const $clickedClose = $(e.currentTarget);
            hideModal($clickedClose);
        });

        //добавить в корзину
        $('[data-add-to-cart]').on('click', () => {
            const $chosenSize = $('.switcher.chosen');

            //если не выбран размер и есть блок с предупреждением о невыбранном размере
            if ($chosenSize.length === 0 && $('.no-sizes-chosen').length) {
                $('[data-no-sizes-chosen]').css('opacity', 1);
                return;
            }

            if (isAdditionalDataFilled()) {
                const isOptionsChecked = $('#additional_options').prop('checked');
                let errors = 0;

                //если чекбокс опций чекнут - проверяем заполняемость инпутов
                if(isOptionsChecked){
                    if($('#custom_shirt_family').val() === ''){
                        $('[data-no-logo-chosen-fio]').css('display', 'block');
                        errors++;
                    }

                    if($('#custom_shirt_number').val() === ''){
                        $('[data-no-logo-chosen-number]').css('display', 'block');
                        errors++;
                    }

                    if(errors > 0){
                        return;
                    }
                }
                PRODUCT_INFO.id = $chosenSize.data('id');
                addToCart('customShirt');

            } else {

                PRODUCT_INFO.id = $chosenSize.data('id');

                //если страница без размеров - берём из json
                if(!$('.sizes-title').length){
                    PRODUCT_INFO.id = defaultProductId;
                }

                addToCart();
            }
        });
    }

    //запрос добавления в корзину
    function addToCart(productType = '') {
        let productData = {};
        const productName = $('[data-product-name]').text();
        const chosenSizeId = $('body').find('.switcher.chosen').data('size');
        const chosenSizeText = $('body').find('.switcher.chosen').text();
        let chosenCount = 1;

        //если на стр есть селект - берём из него значение
        if ($('.select.choices__input').length) {
            chosenCount = $('.select.choices__input').val();
        }

        //если продукт - кастомная майка, раскрыта Доп панель и данные внутри этой панели не пустые - добавляем в запрос
        if (productType === 'customShirt') {
            const familyVal = $familyInput.val();
            const numberVal = $numberInput.val();
            const $chosenLogos = $('[data-checkboxes]').find('.custom-checkbox-label.checked');
            let chosenLogosValue = [];

            if ($chosenLogos.length !== 0) {
                $chosenLogos.each((_, logo) => {
                    chosenLogosValue.push(
                        {
                            logoId: $(logo).data('logo-id'),
                            logoName: $(logo).data('logo-name')
                        }
                    )
                });
            }

            productData = {
                itemId: PRODUCT_INFO.id,
                price: PRODUCT_INFO.price,
                size: chosenSizeId,
                sizeText: chosenSizeText,
                name: productName,
                count: chosenCount,
                customShirtLastName: familyVal,
                customShirtNumber: numberVal,
                customShirtLogos: chosenLogosValue
            }

        } else {
            const img = $('#product-swiper').find('img').first().attr('src');
            let productPagePrice = $('.switcher.size-2.chosen').data('price');

            if($('.switcher.size-2.chosen').data('saleprice')){
                productPagePrice = $('.switcher.size-2.chosen').data('saleprice');
            }


            productData = {
                itemId: PRODUCT_INFO.id,
                price: productPagePrice,
                size: chosenSizeId,
                sizeText: chosenSizeText,
                name: productName,
                count: chosenCount,
                img
            }
        }

        ajaxAddToCart(productData, productType);
    }

    function isAdditionalDataFilled() {
        if ($familyInput.length && $familyInput.val() !== '') {
            return true;
        }

        if ($numberInput.length && $numberInput.val() !== '') {
            return true;
        }

        if ($('#additional_options').prop('checked')) {
            return true;
        }

        return false;
    }
}





